import { localStorageKeys } from '@pkg/types';

import { useProfileMemoryStore } from '@app/store/zustand/profile-page/useProfileNotificationsStore';

export function setLocalStorageItems(items: { key: string; value: string }[]) {
    items.forEach((item) => {
        localStorage.setItem(item.key, item.value);
    });
}

export function removeLocalStorageItems(keys: string[]) {
    keys.forEach((key) => {
        localStorage.removeItem(key);
    });
}

export function removeAllLocalStorageItems() {
    const allLocalStorageKeys = Object.values(localStorageKeys);
    removeLocalStorageItems(allLocalStorageKeys);
}

function getLocalStorageItems(): Record<string, string> {
    const localStorageItems = {};
    const localStorageLength = localStorage.length;
    for (let i = 0; i < localStorageLength; i++) {
        const key = localStorage.key(i);
        if (key) {
            const value = localStorage.getItem(key);
            localStorageItems[key] = value;
        }
    }
    return localStorageItems;
}

function getLocalStorageKeys(): string[] {
    const localStorageItems = getLocalStorageItems();
    return Object.keys(localStorageItems) || [];
}

export function clearLocalStorage({ ignoreKeys = [] }: { ignoreKeys?: string[] } = {}) {
    // Get items we want to save
    const profilePersistStore = useProfileMemoryStore.getState();

    if (ignoreKeys) {
        const localStorageKeys = getLocalStorageKeys();
        const itemsToRemove = localStorageKeys.filter((item) => !ignoreKeys.includes(item));
        removeLocalStorageItems(itemsToRemove);
    } else {
        // No keys to ignore, clear everything
        localStorage.clear();
    }

    // Restore specific items
    useProfileMemoryStore.setState((state) => ({ ...state, ...profilePersistStore }));
}
